import * as Constants from "../constants";

export const setLivePageLoading = () => ({
  type: Constants.SET_LIVE_PAGE_LOADING,
});

export const setLivePageInitialState = () => ({
  type: Constants.SET_LIVE_PAGE_INITIAL_STATE,
});
